import { BasicsClass } from '@/common/BasicsClass';

export class DeviceAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getDeviceTableList', {
            url: '/admin/user/deviceList',
            name: 'list',
            label: '列表'
        }],
    ])


    // // 设备列表
    public getDeviceTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getDeviceTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }


}